import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerCannotDecryptPartnerUserPrivateKeyError extends BaseEitherError {}

export type TKeysManagerDecryptPartnerUserPrivateKeyOperationErrors =
  KeysManagerCannotDecryptPartnerUserPrivateKeyError;
